export const LOAD_INFO_SUCCESS = "LOAD_INFO_SUCCESS";
export const LOAD_RETIRED_SUCCESS = "LOAD_RETIRED_SUCCESS";
export const LOAD_ROSTER_SUCCESS = "LOAD_ROSTER_SUCCESS";
export const LOAD_STATS_SUCCESS = "LOAD_STATS_SUCCESS";
export const LOAD_TRIVIA_SUCCESS = "LOAD_TRIVIA_SUCCESS";

export const GET_SCHEDULE_SUCCESS = "GET_SCHEDULE_SUCCESS";